import React from "react";

export const PelletGoIcon = ({ size = 15, fill = "#29394D" }) => (
    <svg
    width="14"
    height="14"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M11.4542 0H7.09053C6.78929 0 6.54507 0.244219 6.54507 0.545461C6.54507 0.846703 6.78929 1.09092 7.09053 1.09092H10.1373L4.52305 6.70524C4.31003 6.91826 4.31003 7.26359 4.52305 7.47661C4.62953 7.58311 4.76912 7.63636 4.90871 7.63636C5.04831 7.63636 5.18792 7.58313 5.29442 7.47659L10.9087 1.8623V4.9091C10.9087 5.21034 11.153 5.45456 11.4542 5.45456C11.7554 5.45456 11.9997 5.21034 11.9997 4.9091V0.545461C11.9996 0.244219 11.7554 0 11.4542 0Z"
        fill="#29394D"
      />
      <path
        d="M9.27272 5.45485C8.97148 5.45485 8.72726 5.69907 8.72726 6.00031V10.9094H1.0909V3.27303H6C6.30124 3.27303 6.54546 3.02881 6.54546 2.72757C6.54546 2.42632 6.30124 2.18213 6 2.18213H0.545461C0.244219 2.18213 0 2.42635 0 2.72759V11.4549C0 11.7561 0.244219 12.0003 0.545461 12.0003H9.27274C9.57398 12.0003 9.8182 11.7561 9.8182 11.4548V6.00031C9.81818 5.69907 9.57396 5.45485 9.27272 5.45485Z"
        fill="#29394D"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>

);
